import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import type { InKindRedemptionEntryParams } from '../trackers/in-kind-redemption';
import { trackInKindRedemptionEntryViewed } from '../trackers/in-kind-redemption';

/**
 * Fires once per form/dialog mount, when the IKR secondary CTA first becomes visible.
 * The CTA is amount-dependent, so the hook stays mounted while `enabled` follows its
 * actual render conditions and does not inflate impressions if the user edits twice.
 */
export const useTrackInKindRedemptionEntryViewed = t0 => {
  const $ = _c(6);
  const {
    enabled,
    source,
    chainId,
    vaultAddress
  } = t0;
  const tracked = useRef(false);
  let t1;
  let t2;
  if ($[0] !== chainId || $[1] !== enabled || $[2] !== source || $[3] !== vaultAddress) {
    t1 = () => {
      if (!enabled || tracked.current) {
        return;
      }
      tracked.current = true;
      trackInKindRedemptionEntryViewed({
        source,
        chainId,
        vaultAddress
      });
    };
    t2 = [enabled, source, chainId, vaultAddress];
    $[0] = chainId;
    $[1] = enabled;
    $[2] = source;
    $[3] = vaultAddress;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
};